import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appConfigActions from '../Actions/appConfigActions';
import AppConfigList from "../Components/AppConfig/AppConfigList";
import { appConfigService } from "../Services/AppConfigService.js";

class AppConfigConteiner extends Component {
	constructor(props){
		super(props);
		
		this.handleConfigChange=this.handleConfigChange.bind(this);
	}
	
	componentDidMount() {
		appConfigService.listAppConfigs()
					.then(response => {return this.props.actions.fetchAppConfigRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	handleConfigChange(configKey, value){
		appConfigService.setAppConfig(configKey, value)
			.then(response => {return appConfigService.listAppConfigs()
					.then(response => {return this.props.actions.fetchAppConfigRecords(response.data);})
					})
			.catch(err => {/*console.log(err);*/});
			
	}
	
	render(){
		return (<AppConfigList  appConfigRecords={this.props.appConfig}
								handleConfigChange={this.handleConfigChange}/>);
	}
}

function mapStateToProps(state, ownProps) {
	return {user: state.user, appConfig: state.appConfig}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(appConfigActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(AppConfigConteiner);  